import React, { Component } from 'react';
import TableHead from '../component/TableHead.js';
import InputSelect from '../component/InputSelect.js';
import Submit from '../component/Submit.js';
import axios from 'axios';
import {path,mail} from './routes.js';
import Validation from './Validation.js';
import Modal from 'react-modal';
import loader from '../asset/img/loader.gif';
import sparkles2 from '../asset/img/sparkles2.png';

export default class BulkThankyou extends Component{
	constructor(props){
		super(props);
		this.state = {thankyous:[],submit:false,rows:5,virtues:[],employees:[],failed:[],loading:false,incomplete:false,messagePrompt:''};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.addRows = this.addRows.bind(this);
		this.isValidDate = this.isValidDate.bind(this);
		this.openModal = this.openModal.bind(this);
    	this.closeModal = this.closeModal.bind(this);
    	this.loadingFunc = this.loadingFunc.bind(this);
    	this.logsubmit = this.logsubmit.bind(this);
	}

	isValidDate(dateString){ //method for checking whether or not a date is in valid date format and is indeed an actual date that exists
		let d = new Date();
	    let year = d.getFullYear();
	    let dateparts;
	    let dateYear;
	    if(Validation("date",dateString)){
	    	if(dateString.indexOf("/") !== -1){
	    		dateparts = dateString.split("/");
	    		if(dateparts.length === 3){
	    			dateYear = Number(dateparts[2]);
	    		}else{
	    			if(dateparts[0].indexOf("-") !== -1){
	    				dateYear = dateparts[1];
	    			}else{
	    				let dateparts2 = dateparts[1].split("-");
	    				dateYear = dateparts2[1];
	    			}
	    		}
	    	}else{
	    		dateparts = dateString.split("-");
	    		if(dateparts.length === 3){
	    			dateYear = Number(dateparts[2]);
	    		}else{
	    			if(dateparts[0].indexOf("/") !== -1){
	    				dateYear = dateparts[1];
	    			}else{
	    				let dateparts2 = dateparts[1].split("/");
	    				dateYear = dateparts2[1];
	    			}
	    		}
	    	}
	    	if(Number(dateYear) === Number(year)){
	    		return true;
	    	}
	    }
	    return false;
	}

	loadingFunc(loading){ //method to trigger the displaying of the loading gif
		if(loading){
			this.setState({loading:true,modalIsOpen:true});
		}else{
			this.setState({loading:false});
		}
	}

	componentDidMount(){ //when component mounts, retrieve all lov values and currently active employees from database
		axios({ //retrieve lov values 
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{"endpoint":'info',table:'virtues'}
		}).then((response)=>{
			let virtues = [];
			let data = response.data.data;
			data.forEach((virtue)=>{
				virtues.push(virtue.virtue);
			});
			this.setState({virtues:virtues});
		});
		axios({ //retrieve all active employees
			method:'post',
			url: path,
			data:{endpoint:'info',table:'users',action:'employees'}
		}).then((response)=>{
			let employees = [];
			let data = response.data.data;
			data.forEach((employee)=>{
				if(employee.name !== this.props.userInfo.name){
					employees.push({value:employee.name,label:employee.name});
				}
			});
			this.setState({employees:employees});
		});
	}

	handleChange(thankyou){ //method grabs all of the thankyous and adds them to the state since each thankyou is contained in the inputSelect component
		this.setState(oldState => ({thankyous:[...oldState.thankyous,thankyou]}));
	}

	logsubmit(failure){ //method that keeps track of incomplete thankyous
		this.setState({incomplete:failure});
	}

	handleSubmit(){ //method that sets submit to true, which sets all operations for submitting the thank yous into motion
		this.setState({submit:true},function(){
			this.loadingFunc(true);
		});
	}

	addRows(){ //method to increment the number of rows (input select components rendered)
		let oldRows = this.state.rows;
		let newRows = oldRows + 3;
		this.setState({rows:newRows});
	}

	openModal() { //method to open the modal
	   this.setState({modalIsOpen: true});
	}

	closeModal() { //method to close the modal
	    this.setState({modalIsOpen: false,submit:false,failed:[]});
	}

	componentDidUpdate(prevProps,prevState){
		if((prevState.submit === true) && (prevState.thankyous !== this.state.thankyous) && this.state.thankyous.length !== 0){ //if the submit button has been clicked
			let bulkThankyou = this.state.thankyous;
			let thankyous = [];
			let failed = [];
			let reason;
			bulkThankyou.forEach((thankyou)=>{ //validate each thankyou before sending
				if((thankyou.for !== ''&& thankyou.for!==undefined)  && thankyou.from !== 'Select' && thankyou.to !== 'Select' && thankyou.value !== 'Select' && thankyou.date !== '' && thankyou.complete){
					if(Validation("reason",thankyou.for) && Validation('date',thankyou.date)){ //validate the reason and date
						reason = thankyou.for.replace(/\n/g,"<br/>").trim();
						thankyous.push(axios({
							method:'post',
							url:path,headers:{'Content-Type':'application/json'},
							data:{endpoint:'create',table:'thank',misc:'bulk',status:thankyou.from,name:thankyou.to,desc:reason,answer:thankyou.value,date:thankyou.date}
						}).catch((error)=>{
							failed.push(thankyou);
						}));
					}else{
						failed.push(thankyou);
					}
				}else{
						failed.push(thankyou);
				}
			});
			this.setState({submit:false});
			this.setState({failed:failed},function(){ //send all thankyous
				axios.all(thankyous).then((response)=>{
					this.setState({thankyous:[],messagePrompt:'All thank yous created successfully!'});
						this.props.logChange();
						this.loadingFunc(false);
				});
			});
		}else if(prevState.submit === true && this.state.submit){
			this.setState({submit:false,messagePrompt:'Please Input at least one thank you.'});
			this.loadingFunc(false);
		}
	}

	render(){
		let content;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'600px',
		    minHeight:'150px',
		    maxHeight:'600px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 160px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
	let modalContent;
    let failed = this.state.failed;
		const tableRows = [];
		for(var i = 0; i < this.state.rows; i++){ //generate rows of inputs for thank yous
    		tableRows.push(<InputSelect key={i} prefix={i} onChange={this.handleChange} submit={this.state.submit} virtues={this.state.virtues} employees={this.state.employees} failed={this.logsubmit}/>);
    }
    if(this.state.loading){ //display loader
    	modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
    }else if(failed.length > 0){ //display all thankyous that failed from either connection
    	modalContent = <div className="tc mt0">
			    							<div className="fl w-100 tr pb2">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
			    						<p className="tc b f4 navy">There was a problem creating the following thank yous: </p>
			  							<div style={{overflowY:'auto',overflowX:'hidden'}}><UnOrderedList failed={failed}/></div>
			  						</div>;
    }else{ //display message
    	modalContent = <div className="tc mt0">
								    	<div className="fl w-100 tr pb2">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
								    	<p className="tc b f3 navy mt0">{this.state.messagePrompt}</p>
							    	</div>
    }
    if(this.props.active){
    	content = <div>
  							<div className="br3 pa3" style={{boxShadow:'0px 0px 5px 5px #aaaaaa inset'}}>
									<div style={{maxWidth:'100%'}}>
										<table className="fl w-100">
											<thead>
												<TableHead columns={["To","From","For","Value","Date"]}/>
											</thead>
											<tbody>
												{tableRows}
											</tbody>
										</table>
									</div>
									<div className="tr mr3">
										<a href="#" onClick={this.addRows} className="blue no-underline underline-hover">+Add Rows</a>
									</div>
								</div>
								<div className="mt4 mb2">
									<Submit name="Submit" onClick={this.handleSubmit} styles="br3 white b w-20-ns w-50 hh3 bg-navy shadow-3"/>
								</div>
								<div>
									<Modal
						          isOpen={this.state.modalIsOpen}
						          style={customStyles}
						          contentLabel="Bulk Thankyou Modal"
						          shouldCloseOnOverlayClick={false}
						          shouldCloseOnEsc={false}
						        >
						        {modalContent}
						        </Modal>
								</div>
							</div>;
    }
		return(
			<div>
				{content}
			</div>
		);
	}
}

const UnOrderedList = props =>{ //unordered list functional component to display failed thank yous
	let li = props.failed.map((failed,i)=>{
		return <li key={i} className="fl w-100 pl2"><p className="fl w-50 b f5 navy pa0 mt0 tl">To: {failed.to}</p><p className="fl w-50 b tl f5 navy pa0 mt0">From: {failed.from}</p><p className="fl w-100 b f5 bb b--light-silver tl navy pa0 mt0">For: {failed.for}</p></li>;
	});
	return <ul className="fl w-100">{li}</ul>;
}


// WEBPACK FOOTER //
// ./src/container/BulkThankyou.js